package pl.decks.personal.components.widgets.ranks.shapes

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.toAttrs
import pl.decks.personal.components.widgets.ranks.SVGPoint
import pl.decks.personal.components.widgets.ranks.x
import pl.decks.personal.components.widgets.ranks.y

@Composable
fun RankChevron(
    curviness: Float = 0.45f,
    color: Color = Colors.White,
    strokeWidth: Float = 12f,
    modifier: Modifier = Modifier,
) {
    val width = 100f
    val height = 20f

    val left: SVGPoint = 0f to 0f
    val right: SVGPoint = width to 0f

    val controlLeft: SVGPoint = 0.5f * width to height * curviness
    val controlRight: SVGPoint = 0.5f * width to height * curviness
    val tip: SVGPoint = width * 0.5f to height

    val d = buildString {
        append("M ${left.x} ${left.y} ")
        append("Q ${controlLeft.x} ${controlLeft.y}, ${tip.x} ${tip.y} ")
        append("Q ${controlRight.x} ${controlRight.y}, ${right.x} ${right.y}")
    }

    Box(modifier) {
        Svg(
            attrs = Modifier
                .fillMaxSize()
                .overflow(Overflow.Visible)
                .toAttrs {
                    attr("viewBox", "0 0 $width $height")
                    attr("preserveAspectRatio", "none")
                }
        ) {
            Path {
                attr("d", d)
                attr("stroke", color.toString())
                attr("stroke-width", strokeWidth.toString())
                attr("stroke-linecap", "sharp")
                attr("stroke-linejoin", "sharp")
                attr("fill", "none")
            }
        }
    }
}
